import { InjectionToken } from '@angular/core';
import { IHomeRepository } from '../../domain/repository/home.respository';

export const HOME_REPOSITORY = new InjectionToken<IHomeRepository>(
  'IHomeRepository',
);
